import { yupResolver } from '@hookform/resolvers/yup';
import axios from 'axios';
import { Controller, useForm } from 'react-hook-form';
import { useDispatch } from 'react-redux';
import * as yup from 'yup';

import { CHANNEL_NAME_MAX_LENGTH } from 'utils';
import { profileActions } from 'store/actions';
import { api, LoggerService } from 'services';
import { useToast } from 'hooks';
import { Input, Loader } from 'components';

import styles from './FreeTrialPanel.CreateChannel.module.scss';

export type CreateChannelProps = {
  onSuccess?(): void;
};

export type FormValues = {
  name: string;
};

export const validationSchema = yup.object().shape({
  name: yup
    .string()
    .required('Channel name is required')
    .matches(/^[a-zA-Z0-9_]+$/, 'Letters, numbers and _ allowed')
    .max(CHANNEL_NAME_MAX_LENGTH, 'Channel name is too long')
});

const CreateChannel = ({ onSuccess }: CreateChannelProps) => {
  const dispatch = useDispatch();
  const toast = useToast();

  const form = useForm<FormValues>({
    resolver: yupResolver(validationSchema),
    defaultValues: {
      name: ''
    }
  });

  const handleOnSubmit = async (validValues: FormValues) => {
    const channelName = validValues.name.trim();

    try {
      await api.requests.ltv.createChannel({ name: channelName });

      const { data: profileData } = await api.requests.ltv.getUser();

      dispatch(profileActions.setUser(profileData));
      onSuccess?.();
    } catch (error) {
      LoggerService.log('SUBMIT_CREATE_CHANNEL', error);

      if (axios.isAxiosError(error)) {
        if (error.response?.data && 'message' in error.response.data) {
          form.setError('name', {
            type: 'server',
            message: error.response.data.message
          });
        }
      } else if (error instanceof Error) {
        toast.error(error.message, { id: 'CREATE_CHANNEL' });
      } else {
        toast.error('Failed to create a channel', { id: 'CREATE_CHANNEL' });
      }
    }
  };

  return (
    <div className={styles.container}>
      <form onSubmit={form.handleSubmit(handleOnSubmit)}>
        {form.formState.isSubmitting && <Loader />}

        <div className={styles.name}>
          <Controller
            name="name"
            control={form.control}
            render={({ field }) => (
              <Input
                label="Channel name"
                before="livetalks.tv/"
                invalid={!!form.formState.errors.name}
                placeholder="your channel"
                feedback={form.formState.errors.name?.message}
                {...field}
              />
            )}
          />
        </div>

        <button type="submit">Create your channel</button>
      </form>
    </div>
  );
};

export default CreateChannel;
